(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sectionIds = [
    'hero_iyt6zg',
    'section_8mVzWr',
    'collection_list_PyqNUa',
    'collection_list_UhxgRK',
    'featured_product_mTUbKC',
    'section_F9fMc4',
    'section_bEAgiX',
    'ss_testimonials_2_3LGNPR'
  ];

  sectionIds.forEach((id) => {
    const wrapper = document.querySelector(`[id*="${id}"]`);
    const revealTarget = wrapper?.querySelector('.section, .hero, [class*="testimonials-"]');
    if (revealTarget) revealTarget.dataset.avReveal = '';
  });

  const hero = document.querySelector('.template-index .hero');
  const featured = document.querySelector('.template-index .featured-product-section');
  const roots = [hero, featured].filter(Boolean);

  roots.forEach((root) => {
    root.dataset.avDepthRoot = '';
    root.dataset.avDepthDistance = root === hero ? '52' : '24';
  });

  const revealItems = Array.from(document.querySelectorAll('[data-av-reveal]'));
  document.documentElement.classList.add('av-motion-ready');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  if (!roots.length || reducedMotion.matches) return;

  let ticking = false;
  const updateDepth = () => {
    const viewportHeight = window.innerHeight;
    const mobile = window.innerWidth < 750;
    roots.forEach((root) => {
      const rect = root.getBoundingClientRect();
      const travel = viewportHeight + rect.height;
      const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / travel));
      const distance = Number(root.dataset.avDepthDistance || (mobile ? 16 : 48));
      root.style.setProperty('--av-depth-y', `${(progress - 0.5) * distance}px`);
    });
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateDepth);
  };

  updateDepth();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-av-reveal]').forEach((item) => item.classList.add('is-visible'));
  });
})();
